import { createRoutine } from 'redux-saga-routines';
import { LIST_LEADS_SATISFACTION } from './types';

export const listLeadsSatisfaction = createRoutine(LIST_LEADS_SATISFACTION);

export default listLeadsSatisfaction;
